import { IFilterHierarchy } from '../types/planning.types';

export const serializeFilters = (filters?: IFilterHierarchy): string => {
	if (!filters) return 'no-filters';

	return JSON.stringify({
		productIds: filters.productIds?.sort() || [],
		commercialIds: filters.commercialIds?.sort() || [],
		customerIds: filters.customerIds?.sort() || [],
	});
};
